import React from 'react';
import { EmailValidationIndicator } from '@shared/ui/EmailValidationIndicator';
import { OtpVerificationForm } from '../OtpVerificationForm';
import type { VerifyOtpResult } from '@features/auth/hooks';

interface OtpStepProps {
  email: string;
  isNewUser: boolean;
  emailValidationStatus: string;
  emailInvalidReason: string | null;
  onChangeEmail: () => void;
  onBack: () => void;
  onSuccess: (
    user: VerifyOtpResult['user'],
    tokens: VerifyOtpResult['tokens'],
    isNewUser: boolean
  ) => void;
}

export const OtpStep: React.FC<OtpStepProps> = ({
  email,
  isNewUser,
  emailValidationStatus,
  emailInvalidReason,
  onChangeEmail,
  onBack,
  onSuccess
}) => {
  return (
    <>
      <EmailValidationIndicator
        status={emailValidationStatus as never}
        reason={emailInvalidReason ?? undefined}
        onChangeEmail={onChangeEmail}
        className="mb-4"
      />
      <OtpVerificationForm
        email={email}
        isNewUser={isNewUser}
        isSubmitDisabled={emailValidationStatus === 'invalid'}
        onBack={onBack}
        onSuccess={onSuccess}
      />
    </>
  );
};
